import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import axios from 'axios';
import { Card, CardBody, CardHeader } from 'reactstrap';

import cogoToast from 'cogo-toast';
import {
  CREATE_CLIENT_USER,
  GET_BENEFIT_ITEMS,
  GET_BINS_LIST,
  GET_CLIENT_BENEFIT_CONFIG,
  GET_MEMBERSHIPS_DATA,
} from '../../../../../../../../store/actions';
import { customHeaders, uaeProjectsBaseURL } from '../../../../../../../Config';
import { Constant } from '../../../../../../../Helpers/constant';
import PersonalDetails from './PersonalDetails';
import { Loader } from '../../../../../../../Common';

export default function PersonalDetailsPage({
  isUserExist,
  setIsUserExist,
  setSelectedConfig,
  bookingsDetails,
  setBookingsDetails,
  setCurrentScreen,
}) {
  const history = useHistory();

  /* ---------------------------- LOCAL STATES ---------------------------- */
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const [searchUserLoading, setSearchUserLoading] = useState(false);
  const [isUserUpdate, setisUserUpdate] = useState(false);
  const [isCreateUser, setIsCreateUser] = useState(true);
  const [binNumberForCreateUser, setBinNumberForCreateUser] = useState(null);

  const { createUser, createUserLoading, checkState } = useSelector((state: any) => ({
    createUser: state?.CreateClientUser?.data,
    checkState: state,
    createUserLoading: state?.CreateClientUser?.loading,
  }));

  const { updateUserLoading } = useSelector((state: any) => ({
    updateUserLoading: state?.UpdateProfile?.loading,
  }));

  const { membershipData, membershipDataLoading } = useSelector((state: any) => ({
    membershipData: state.GetMembershipsData?.data?.results,
    membershipDataLoading: state.GetMembershipsData.loading,
  }));

  const { clientBenefitConfig, clientBenefitConfigLoading } = useSelector((state: any) => ({
    clientBenefitConfig: state.GetClientBenefitConfig.data?.results,
    clientBenefitConfigLoading: state.GetClientBenefitConfig.loading,
  }));

  const { getBenefitItems, getBenefitItemsLoading } = useSelector((state: any) => ({
    getBenefitItems: state.GetBenefitItems.data?.results,
    getBenefitItemsLoading: state.GetBenefitItems.loading,
  }));

  useEffect(() => {
    if (createUser !== null) {
      dispatch({
        type: GET_MEMBERSHIPS_DATA,
        payload: {
          urlParams: {
            userId: createUser?.user?.userId,
          },
        },
      });
      createUser.user.binNumber = binNumberForCreateUser;
      setIsUserExist(createUser?.user);
    }
  }, [createUser]);

  useEffect(() => {
    if (getBenefitItems !== null) {
      // console.log('getBenefitItems', getBenefitItems);
    }
  }, [getBenefitItems]);

  useEffect(() => {
    dispatch({
      type: GET_BINS_LIST,
    });
  }, []);

  useEffect(() => {
    if (membershipData?.length > 0) {
      const { benefitGroupId, membershipId, objectId } = membershipData[0];
      dispatch({
        type: GET_CLIENT_BENEFIT_CONFIG,
        payload: {},
      });
    }
  }, [membershipData]);

  useEffect(() => {
    if (clientBenefitConfig?.length > 0) {
      const benefitConfigDetails = clientBenefitConfig?.find(
        config => config?.bookingType?.typeId === Constant?.bookingTypes?.PICK_AND_DROP_BOOKINGS,
      );

      if (benefitConfigDetails) {
        setSelectedConfig(benefitConfigDetails);
        setCurrentScreen(`BOOKING_FLOW`);
      }

      dispatch({
        type: GET_BENEFIT_ITEMS,
        payload: {
          urlParam: {
            benefitConfigId: benefitConfigDetails?.objectId,
            userId: isUserExist?.userId,
          },
        },
      });

      // dispatch({
      //   type: GET_CLIENT_AIRPORT,
      //   payload: {
      //     urlParam: {
      //       objectIds: benefitConfigDetails?.airports,
      //     },
      //   },
      // });

      setBookingsDetails({
        membershipId: membershipData[0]?.objectId,
        benefitConfigId: benefitConfigDetails?.objectId,
        address: isUserExist?.addresses,
        tat: benefitConfigDetails?.tat,
        remainingBookings: benefitConfigDetails?.remainingBookings,
        carTypes: benefitConfigDetails?.carTypes,
      });
    }
  }, [clientBenefitConfig]);

  const searchUser = async (phoneNumber: string, countryCode: string) => {
    setSearchUserLoading(true);
    const userDetails = await axios({
      method: `GET`,
      url: `${uaeProjectsBaseURL}/admin/v1/fetch-customer-details`,
      headers: {
        Authorization: Constant.CLIENT_TOKEN,
        ...customHeaders,
        'X-Requested-By': 'one-admin',
      },
      params: {
        phoneNumber: phoneNumber,
        countryCode: countryCode,
      },
    });
    if (userDetails?.data) {
      setIsUserExist(userDetails?.data);
    } else {
      cogoToast.warn('user not found');
    }
    setIsCreateUser(false);
    setSearchUserLoading(false);
  };

  const submitUser = async data => {
    if (isUserExist) {
      if (!isUserUpdate) {
        dispatch({
          type: GET_MEMBERSHIPS_DATA,
          payload: {
            urlParams: {
              userId: isUserExist?.userId,
            },
          },
        });
        setIsUserExist({ ...isUserExist, binNumber: data?.binNumber });
      } else {
        // toggleTab(2, 50);
        alert('go a head');
      }
      return;
    }
    dispatch({
      type: CREATE_CLIENT_USER,
      payload: {
        data: {
          firstName: data?.name?.split(' ')[0] ?? '',
          lastName: data?.name?.split(' ')?.[1] ?? '',
          countryCode: data?.countryCode,
          phoneNumber: data?.phoneNumber,
          email: data?.email,
          card: {
            binId: data?.binNumber?.data?.binId,
            first: data?.binNumber?.data?.number,
          },
        },
      },
    });
    setBinNumberForCreateUser(data?.binNumber);
  };

  useEffect(() => {
    if (
      createUserLoading ||
      membershipDataLoading ||
      clientBenefitConfigLoading ||
      getBenefitItemsLoading ||
      searchUserLoading ||
      updateUserLoading
    ) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [createUserLoading || membershipDataLoading || clientBenefitConfigLoading || getBenefitItemsLoading || searchUserLoading || updateUserLoading]);

  return (
    <>
      {loading && <Loader />}

      <Card>
        <CardHeader className="d-flex justify-content-end">
          <h6 className="card-title mb-0 flex-grow-1 custom-card-title"> Personal Details </h6>
        </CardHeader>

        <CardBody>
          <PersonalDetails
            searchUser={searchUser}
            submitUser={submitUser}
            isUserExist={isUserExist}
            setIsUserExist={setIsUserExist}
            setisUserUpdate={setisUserUpdate}
            isCreateUser={isCreateUser}
            searchUserLoading={searchUserLoading}
          />
        </CardBody>
      </Card>
    </>
  );
}
